export const types = {
  AuthToken: "auth-token-header",
  ScreenSize: "width-of-screen",
};

export const dataFilterStates = {};

export const actionModes = {
  APPEND_TO_ARRAY: "append-to-array",
  REPLACE: "replace-value",
  REMOVE_FROM_ARRAY: "remove-value-from-array",
};
